function reshapePromotionsResponse(promotions) {
  return promotions.map(promo => {
    return {
      ...promo.audiobook,
      currentProduct: promo.product,
    };
  });
}

function errorCode(error) {
  return _.get(error, ['response', 'errors', '0', 'extensions', 'code']);
}

export const graphQLHelpers = {
  reshapePromotionsResponse,
  errorCode,
};
